import { useAtom } from 'jotai'
import { SearchItem } from 'lib/models'
import { createAtom } from './atomFactory'
import { MMKVKey } from '../mmkv'

const { atom, resetAtom } = createAtom<Array<SearchItem>>([], MMKVKey.SearchItems)

export const useSearchItemsAtom = () => useAtom(atom)
export const useResetSearchItemsAtom = () => useAtom(resetAtom)
